import classNames from 'classnames/bind';

import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

import styles from './ContextMenu.module.scss';

const c = classNames.bind(styles);

export function ContextMenuSeparator() {
  return <DropdownMenu.Separator className={c('separator')} />;
}
